import { render, staticRenderFns } from "./MySubmissions.vue?vue&type=template&id=18fd4c8a"
import script from "./MySubmissions.vue?vue&type=script&lang=js"
export * from "./MySubmissions.vue?vue&type=script&lang=js"
import style0 from "./MySubmissions.vue?vue&type=style&index=0&id=18fd4c8a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports